import { motion } from 'framer-motion'

export function OlhoAnimadoInput({ open }: { open: boolean }): JSX.Element {
  return (
    <motion.svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      initial={false}
      animate={{
        rotate: open ? 0 : -15
      }}
      transition={{ duration: 0.25 }}
    >
      <motion.path
        d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"
        animate={{
          opacity: open ? 1 : 0.4,
          scaleY: open ? 1 : 0.65
        }}
        transition={{ duration: 0.25 }}
      />

      <motion.circle
        cx="12"
        cy="12"
        r="3"
        animate={{
          scale: open ? 1 : 0.2
        }}
        transition={{ duration: 0.2 }}
      />

      {!open && (
        <motion.line
          x1="4"
          y1="4"
          x2="20"
          y2="20"
          stroke="currentColor"
          strokeWidth="2"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.25 }}
        />
      )}
    </motion.svg>
  )
}
